import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { DATA_PRODUCER_TABLE_NAME } from "./constants";

export const setAllQuoteFeedsAsNone = () => {
  Excel.run(async (context) => {
    const worksheet = context.workbook.worksheets.getItemOrNullObject(DATA_PRODUCER_WORKSHEET_NAME);
    const table = worksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);

    table.load(["columns", "isNullObject"]);
    worksheet.load("isNullObject");
    await context.sync();

    if (worksheet.isNullObject || table.isNullObject) return;

    const quoteFeedRange = table.columns.getItem("Quote Feed").getDataBodyRange();

    quoteFeedRange.load("values");
    await context.sync();

    quoteFeedRange.values = quoteFeedRange.values.map(() => ["None"]);

    await context.sync();
  });
};
